import { createCustomElement } from '@angular/elements';
import { createApplication } from '@angular/platform-browser';

import { appConfig } from './floating-button/app.config';
import 'zone.js';
import { AppComponent } from './floating-button/app.component';
import { SupportFormComponent } from './floating-button/components/support-form/support-form.component';

(async () => {
  const app = await createApplication(appConfig);
  const webComponentName = 'pu-floating-button-webcomponent';
  const createRequestFormName = 'pu-create-request-form-webcomponent';

  if (!customElements.get(webComponentName)) {
    const appElement = createCustomElement(AppComponent, {
      injector: app.injector,
    });

    customElements.define(webComponentName, appElement);
  }

  if (!customElements.get(createRequestFormName)) {
    const createRequestFormElement = createCustomElement(SupportFormComponent, {
      injector: app.injector,
    });

    customElements.define(createRequestFormName, createRequestFormElement);
  }
})();
